import React, { useState, useEffect, useContext, useRef } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import RadioGroup from "@mui/material/RadioGroup";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import EmptyIphone from "../../assets/iphone-empty.png";
import TopBar from "../../assets/top-bar.png";

import ShowcaseEmpty from "../../assets/showcase-vouchers-empty.png";
import ShowcaseEmptyInside from "../../assets/showcase-vouchers-empty-inside.png";

import { ADMIN_URL } from "../../utils/constants";
import { Alert, CircularProgress, Tooltip } from "@mui/material";
import { UserContext } from "../../context/UserContext";

import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";

import Tabbar from "../../assets/tabbar-ios-services.png";
import { useDraggable } from "react-use-draggable-scroll";
import ShowcaseTab1 from "../../assets/voucherTabStyle1.png";
import ShowcaseTab2 from "../../assets/voucherTabStyle2.png";

import ShowcaseVoucherShadowSmallImageBigButton from "../../assets/voucherShadowSmallImageBigButton.png";
import ShowcaseVoucherSmallImageBigButton from "../../assets/voucherSmallImageBigButton.png";
import ShowcaseVoucherBigButton from "../../assets/voucherBigButton.png";
import ShowcaseVoucherShadowBigButton from "../../assets/voucherShadowBigButton.png";
import ShowcaseVoucherBigImageBigButton from "../../assets/voucherBigImageBigButton.png";
import ShowcaseVoucherShadowBigImageBigButton from "../../assets/voucherShadowBigImageBigButton.png";
import ShowcaseVoucherShadowBigImageSmallButton from "../../assets/voucherShadowBigImageSmallButton.png";
import ShowcaseVoucherBigImageSmallButton from "../../assets/voucherBigImageSmallButton.png";
import ShowcaseVoucherShadowSmallButton from "../../assets/voucherShadowSmallButton.png";
import ShowcaseVoucherSmallButton from "../../assets/voucherSmallButton.png";
import ShowcaseVoucherSmallImageSmallButton from "../../assets/voucherSmallImageSmallButton.png";
import ShowcaseVoucherShadowSmallImageSmallButton from "../../assets/voucherShadowSmallImageSmallButton.png";
import ShowcaseVoucherDividerSmallImageBigButton from "../../assets/voucherDividerSmallImageBigButton.png";
import ShowcaseVoucherDividerBigImageBigButton from "../../assets/voucherDividerBigImageBigButton.png";
import ShowcaseVoucherDividerBigButton from "../../assets/voucherDividerBigButton.png";
import ShowcaseVoucherDividerSmallButton from "../../assets/voucherDividerSmallButton.png";
import ShowcaseVoucherDividerBigImageSmallButton from "../../assets/voucherDividerBigImageSmallButton.png";
import ShowcaseVoucherDividerSmallImageSmallButton from "../../assets/voucherDividerSmallImageSmallButton.png";
import IconModal from "../../components/IconModal/IconModal";
import fontIcons from "../../assets/font-glyphs/icons.json";

import ShowcaseVouchers from "../../components/ShowcaseVouchers/ShowcaseVouchers";
import ShowcaseTopBar from "../../components/ShowcaseTopBar/ShowcaseTopBar";
import { CreatorContext } from "../../context/CreatorContext";
import ShowcaseTabBar from "../../components/ShowcaseTabBar/ShowcaseTabBar";

const useStyles = makeStyles({
	iphoneContainer: {
		"& *": {
			userDrag: "none",
		},
	},
	iphone: {
		width: 260,
		padding: 20,
		paddingTop: 0,
	},
	cardInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardPageInfo: {
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	cardOptions: {
		display: "flex",
		flexDirection: "column",
	},
	cardForm: {
		display: "flex",
	},
	cardGrid: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	overlayContainer: {
		position: "relative",
	},
	overlay: {
		position: "absolute",
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: "rgba(0, 0, 0, 0.6)",
		color: "white",
		padding: 16,
		borderRadius: 5,
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		justifyContent: "center",
		zIndex: 4,
	},
});

export default function Vouchers({ drawerWidth }) {
	const classes = useStyles();

	const [vouchers, setVouchers] = useState(null);

	const [showSmallImage, setShowSmallImage] = useState(null);
	const [showShadow, setShowShadow] = useState(null);
	const [showDivider, setShowDivider] = useState(null);
	const [buttonStyle, setButtonStyle] = useState("voucherButtonStyle1");
	const [showBigImage, setShowBigImage] = useState(null);
	const [backgroundColor, setBackgroundColor] = useState("#FFFFFF");
	const [imageStyle, setImageStyle] = useState("smallImage");

	const [tabStyle, setTabStyle] = useState(null);

	const [loading, setLoading] = useState(false);
	const { user } = useContext(UserContext);

	const { t } = useTranslation();

	const alert = useAlert();

	const [enableVouchers, setEnableVouchers] = useState(true);

	const [selectedIcon, setSelectedIcon] = useState({});
	const [voucherIconName, setVoucherIconName] = useState(null);
	const [voucherIconType, setVoucherIconType] = useState(null);
	const [showIconMenu, setShowIconMenu] = useState(false);

	const { creator, getCreator } = useContext(CreatorContext);

	const setNewIcon = (icon) => {
		setVoucherIconName(icon.iconName);
		setVoucherIconType(icon.iconType);
	};

	const getImage = () => {
		let image = ShowcaseEmpty;

		return image;
	};

	const Icon = React.memo(({ family, name, ...props }) => (
		<span
			style={{
				fontFamily:
					family === "FontAwesome5"
						? "'FontAwesome5', 'FontAwesome5_Regular', 'FontAwesome5Brands'"
						: family,
			}}
			{...props}
		>
			{String.fromCodePoint(fontIcons[family][name])}
		</span>
	));

	const getMiddleImage = () => {
		let image = ShowcaseEmptyInside;
		if (vouchers === "voucher1") {
			if (showShadow) {
				if (showSmallImage) {
					if (buttonStyle === "voucherButtonStyle1") {
						image = ShowcaseVoucherShadowSmallImageBigButton;
					} else {
						image = ShowcaseVoucherShadowSmallImageSmallButton;
					}
				} else if (showBigImage) {
					if (buttonStyle === "voucherButtonStyle1") {
						image = ShowcaseVoucherShadowBigImageBigButton;
					} else {
						image = ShowcaseVoucherShadowBigImageSmallButton;
					}
				} else {
					if (buttonStyle === "voucherButtonStyle1") {
						image = ShowcaseVoucherShadowBigButton;
					} else {
						image = ShowcaseVoucherShadowSmallButton;
					}
				}
			} else {
				if (showDivider) {
					if (showSmallImage) {
						if (buttonStyle === "voucherButtonStyle1") {
							image = ShowcaseVoucherDividerSmallImageBigButton;
						} else {
							image = ShowcaseVoucherDividerSmallImageSmallButton;
						}
					} else if (showBigImage) {
						if (buttonStyle === "voucherButtonStyle1") {
							image = ShowcaseVoucherDividerBigImageBigButton;
						} else {
							image = ShowcaseVoucherDividerBigImageSmallButton;
						}
					} else {
						if (buttonStyle === "voucherButtonStyle1") {
							image = ShowcaseVoucherDividerBigButton;
						} else {
							image = ShowcaseVoucherDividerSmallButton;
						}
					}
				} else {
					if (showSmallImage) {
						if (buttonStyle === "voucherButtonStyle1") {
							image = ShowcaseVoucherSmallImageBigButton;
						} else {
							image = ShowcaseVoucherSmallImageSmallButton;
						}
					} else if (showBigImage) {
						if (buttonStyle === "voucherButtonStyle1") {
							image = ShowcaseVoucherBigImageBigButton;
						} else {
							image = ShowcaseVoucherBigImageSmallButton;
						}
					} else {
						if (buttonStyle === "voucherButtonStyle1") {
							image = ShowcaseVoucherBigButton;
						} else {
							image = ShowcaseVoucherSmallButton;
						}
					}
				}
			}
		} else if (vouchers === "voucher2") {
		}
		return image;
	};

	const getHomeData = async () => {
		setVouchers("voucher1");
		setLoading(true);
		try {
			const res = await axios.get(ADMIN_URL + "creators", {
				headers: { authorization: localStorage.getItem("token") },
			});

			setEnableVouchers(res.data.enableVouchers);

			setButtonStyle(res.data.voucherButtonStyle);
			setShowSmallImage(res.data.voucherShowSmallImage);
			setShowShadow(res.data.voucherShowShadow);

			setShowDivider(res.data.voucherDivider);
			setShowBigImage(res.data.voucherShowBigImage);
			setBackgroundColor(res.data.voucherBackgroundColor);

			setTabStyle(res.data.voucherTabStyle);

			setVouchers(res.data.voucherType);

			setVoucherIconName(res.data.voucherBuyIconName);
			setVoucherIconType(res.data.voucherBuyType);
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	useEffect(() => {
		getHomeData();
	}, []);

	useEffect(() => {
		getImage();
	}, [vouchers]);

	const saveHomeData = async () => {
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					voucherType: vouchers,
					voucherButtonStyle: buttonStyle,
					voucherShowSmallImage: showSmallImage,
					voucherShowShadow: showShadow,
					voucherShowBigImage: showBigImage,
					voucherBackgroundColor: backgroundColor,
					voucherDivider: showDivider,
					voucherTabStyle: tabStyle,
					voucherBuyIconName: voucherIconName,
					voucherBuyType: voucherIconType,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			getCreator();
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
	};

	const saveEnableVoucher = async (enable) => {
		setLoading(true);
		try {
			await axios.post(
				ADMIN_URL + "creators",
				{
					enableVouchers: enable,
				},
				{
					headers: { authorization: localStorage.getItem("token") },
				}
			);
			setEnableVouchers(enable);
			alert.show(t("general.success"), { type: "success" });
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				bgcolor: "background.default",
				p: 3,
				width: { xs: "100%", sm: "calc(100vw - " + drawerWidth + "px)" },
			}}
		>
			<Toolbar />
			{!loading && enableVouchers && (
				<Alert
					severity="info"
					sx={{
						marginBottom: 2,
						"& .MuiAlert-icon": {
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						},
					}}
					className={classes.alert}
				>
					{t("vouchers.disableVouchers")}
					<Tooltip title={t("vouchers.voucherFunctionality")} placement="right">
						<IconButton>
							<InfoIcon color="action" sx={{ width: 14 }} />
						</IconButton>
					</Tooltip>
					<Button
						color="secondary"
						onClick={() => {
							saveEnableVoucher(false);
						}}
						disabled={loading}
						sx={{ marginLeft: 2 }} // Add some spacing between the text and the button
					>
						{loading ? (
							<CircularProgress size={24} />
						) : (
							t("supercategories.disableButton")
						)}
					</Button>
				</Alert>
			)}
			<Box className={classes.overlayContainer}>
				{!loading && !enableVouchers && (
					<Box className={classes.overlay}>
						<Box
							sx={{
								backgroundColor: "#ffffff",
								padding: 4,
								color: "#000000",
								textAlign: "center",
							}}
						>
							<Typography variant="h6" sx={{ marginBottom: 2 }}>
								{t("vouchers.vouchersDisabled")}
							</Typography>
							<Typography
								variant="body1"
								sx={{ maxWidth: 400, marginBottom: 2 }}
							>
								{t("vouchers.vouchersDescription")} <br /> <br />
								{t("vouchers.importantNote")}
							</Typography>
							<Button
								variant="contained"
								color="primary"
								sx={{ width: 400 }}
								onClick={() => {
									saveEnableVoucher(true);
								}}
							>
								{t("vouchers.enableVoucherButton")}
							</Button>
						</Box>
					</Box>
				)}

				<Card variant="outlined">
					<>
						<CardContent>
							<Typography
								sx={{
									fontSize: 14,
									borderBottom: "1px solid #f0f0f0",
									minHeight: "35px",
									marginBottom: "20px",
									marginLeft: "-20px",
									marginRight: "-20px",
									padding: "0px 20px 20px",
								}}
								color="text.secondary"
								gutterBottom
							>
								{t("vouchers.title")}
							</Typography>
							<Box
								className={classes.cardPageInfo}
								sx={{
									flexFlow: {
										xs: "column-reverse",
										sm: "column-reverse",
										md: "row",
									},
								}}
							>
								<Box
									className={classes.cardOptions}
									sx={{
										minWidth: {
											xs: 0,
											sm: 0,
											md: 400,
										},
									}}
								>
									<RadioGroup
										aria-labelledby="demo-radio-buttons-group-label"
										value={vouchers && vouchers}
										name="radio-buttons-group"
										onChange={(e) => {
											setVouchers(e.target.value.toString());
										}}
									>
										<FormControlLabel
											value="voucher1"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={
												<>
													<b>{t("vouchers.style")} 1</b>:{" "}
													{t("vouchers.voucher1")}
												</>
											}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
									</RadioGroup>
									<Typography
										sx={{
											fontSize: 12,
											marginTop: 2,
											marginBottom: 0,
											fontWeight: 700,
											textTransform: "uppercase",
										}}
										color="text.secondary"
										gutterBottom
									>
										{t("general.chooseOptions")}
									</Typography>

									<FormControlLabel
										ç
										control={
											<Checkbox
												checked={showShadow}
												onChange={(e) => {
													setShowShadow(!showShadow);
												}}
												disabled={[
													"building",
													"built",

													"publishing",
													"published",
													"inviting",
												].find(
													(status) =>
														status ===
														(user.app.appStatuses.length === 0
															? ""
															: user.app.appStatuses.length > 0 &&
															  user.app.appStatuses[0].status)
												)}
											/>
										}
										label={t("vouchers.showShadow")}
									/>
									{!showShadow && (
										<FormControlLabel
											control={
												<Checkbox
													checked={showDivider}
													onChange={(e) => {
														setShowDivider(!showDivider);
													}}
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={t("vouchers.showDivider")}
										/>
									)}
									<Typography
										sx={{
											fontSize: 12,
											marginTop: 2,
											marginBottom: 0,
											fontWeight: 700,
											textTransform: "uppercase",
										}}
										color="text.secondary"
										gutterBottom
									>
										{t("vouchers.buttonStyle")}
									</Typography>
									<RadioGroup
										aria-labelledby="demo-radio-buttons-group-label"
										value={buttonStyle && buttonStyle}
										name="radio-buttons-group"
										onChange={(e) => {
											setButtonStyle(e.target.value.toString());
										}}
									>
										<FormControlLabel
											value="voucherButtonStyle1"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("vouchers.buttonStyle1")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
										<FormControlLabel
											value="voucherButtonStyle2"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("vouchers.buttonStyle2")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
									</RadioGroup>
									<Box
										display={"flex"}
										flexDirection={"row"}
										alignItems={"center"}
										sx={{ marginTop: 2 }}
									>
										<Typography
											sx={{
												fontSize: 12,

												marginBottom: 0,
												fontWeight: 700,
												textTransform: "uppercase",
											}}
											color="text.secondary"
											gutterBottom
										>
											{t("vouchers.icon")}
										</Typography>
										{buttonStyle === "voucherButtonStyle1" && (
											<Tooltip title={t("vouchers.iconCart")} placement="right">
												<IconButton>
													<InfoIcon color="action" sx={{ width: 14 }} />
												</IconButton>
											</Tooltip>
										)}
									</Box>
									<Typography gutterBottom sx={{ marginTop: 2 }}>
										<IconButton
											onClick={() => {
												setSelectedIcon({
													iconType: voucherIconType,
													iconName: voucherIconName,
													selected: false,
												});
												setShowIconMenu(true);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
											sx={{ marginRight: 1 }}
										>
											<Icon
												family={voucherIconType ?? "MaterialCommunityIcons"}
												name={voucherIconName ?? "cart"}
											/>
										</IconButton>
										{t("vouchers.cart")}
									</Typography>
									<Typography
										sx={{
											fontSize: 12,
											marginTop: 2,
											marginBottom: 0,
											fontWeight: 700,
											textTransform: "uppercase",
										}}
										color="text.secondary"
										gutterBottom
									>
										{t("vouchers.imageStyle")}
									</Typography>
									<RadioGroup
										aria-labelledby="demo-radio-buttons-group-label"
										value={imageStyle && imageStyle}
										name="radio-buttons-group"
										onChange={(e) => {
											setImageStyle(e.target.value.toString());
											if (e.target.value.toString() === "smallImage") {
												setShowSmallImage(true);
												setShowBigImage(false);
											} else if (e.target.value.toString() === "bigImage") {
												setShowSmallImage(false);
												setShowBigImage(true);
											} else {
												setShowSmallImage(false);
												setShowBigImage(false);
											}
										}}
									>
										<FormControlLabel
											value="smallImage"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("vouchers.smallImage")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
										<FormControlLabel
											value="bigImage"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("vouchers.bigImage")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
										<FormControlLabel
											value="noImage"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("vouchers.noImage")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
									</RadioGroup>
									<FormControl
										fullWidth
										variant="standard"
										sx={{ marginTop: 4, marginBottom: 0 }}
									>
										<InputLabel
											shrink
											htmlFor="app-name-input"
											sx={{
												marginTop: -2,
												fontWeight: 700,
												textTransform: "uppercase",
												fontSize: 12,
											}}
										>
											{t("general.backgroundColor")}
										</InputLabel>
										<TextField
											id="background-color"
											fullWidth
											variant="outlined"
											type="color"
											value={backgroundColor}
											onChange={(e) => {
												setBackgroundColor(e.target.value);
											}}
											disabled={[
												"building",
												"built",

												"publishing",
												"published",
												"inviting",
											].find(
												(status) =>
													status ===
													(user.app.appStatuses.length === 0
														? ""
														: user.app.appStatuses.length > 0 &&
														  user.app.appStatuses[0].status)
											)}
										/>
										<Box
											sx={{
												backgroundColor: backgroundColor,
												position: "absolute",
												top: "12px",
												left: "12px",
												width: "calc(100% - 24px)",
												height: "16px",
												outline: "1px solid",
												pointerEvents: "none",
												borderRadius: "2px",
											}}
										></Box>
									</FormControl>

									<Typography
										sx={{
											fontSize: 12,
											marginTop: 2,
											marginBottom: 0,
											fontWeight: 700,
											textTransform: "uppercase",
										}}
										color="text.secondary"
										gutterBottom
									>
										{t("yourAppointments.chooseTabStyles")}
									</Typography>
									<RadioGroup
										aria-labelledby="demo-radio-buttons-group-label"
										value={tabStyle && tabStyle}
										name="radio-buttons-group"
										onChange={(e) => {
											setTabStyle(e.target.value.toString());
										}}
									>
										<FormControlLabel
											value="tabStyle1"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("yourAppointments.tabStyle")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
										<FormControlLabel
											value="tabStyle2"
											control={
												<Radio
													disabled={[
														"building",
														"built",

														"publishing",
														"published",
														"inviting",
													].find(
														(status) =>
															status ===
															(user.app.appStatuses.length === 0
																? ""
																: user.app.appStatuses.length > 0 &&
																  user.app.appStatuses[0].status)
													)}
												/>
											}
											label={<>{t("yourAppointments.tabStyle2")}</>}
											sx={{
												marginBottom: {
													xs: 1,
													sm: 1,
													md: 0,
												},
											}}
										/>
									</RadioGroup>
								</Box>
								<div
									className={classes.iphoneContainer}
									style={{ position: "relative" }}
								>
									<img
										src={EmptyIphone}
										alt="iphone"
										onMouseOver={() => {}}
										onMouseLeave={() => {}}
										className={classes.iphone}
									/>

									<img
										src={TopBar}
										alt="iphone"
										onMouseOver={() => {}}
										onMouseLeave={() => {}}
										className={classes.iphone}
										style={{
											position: "absolute",
											top: 0,
											left: 0,
											zIndex: 3,
											WebkitUserDrag: "none",
										}}
									/>

									<Box
										sx={{
											position: "absolute",
											top: 0,
											bottom: 0,
											padding:
												"53.75px 29px 72.25px 30px" /*"55.25px 29px 73px 30.25px",*/,
											width: 260,
											zIndex: 2,
										}}
										draggable={false}
									>
										<Box sx={{ marginTop: "-45px" }}>
											{/* CAMBIAR QUAN TINGUEM EL TIPO DE APP */}
											<ShowcaseTopBar
												title={t("vouchers.vouchers")}
												showDrawer={creator.navigationType === "Drawer"}
											/>
										</Box>
										<Box
											id="showcase"
											sx={{
												width: "100%",
												aspectRatio:
													creator.navigationType === "Drawer"
														? "220 / 427"
														: "220 / 386.5",
												borderBottomRightRadius:
													creator.navigationType === "Drawer" ? "26px" : 0,
												borderBottomLeftRadius:
													creator.navigationType === "Drawer" ? "26px" : 0,
												overflow: "auto",
												display: "flex",
												flexDirection: "column",
												backgroundColor: creator.themeColor,
												color:
													creator.themeMode === "Dark" ? "#ffffff" : "#000000",
											}}
										>
											<ShowcaseVouchers
												showSmallImage={showSmallImage}
												showShadow={showShadow}
												showDivider={showDivider}
												showBigImage={showBigImage}
												buttonStyle={buttonStyle}
												backgroundColor={backgroundColor}
												imageStyle={imageStyle}
												voucherIconType={voucherIconType}
												voucherIconName={voucherIconName}
												tabStyle={tabStyle}
												sector={
													user?.app?.appSubtype?.toLowerCase() ?? "barber"
												}
											/>
										</Box>
										{creator.navigationType === "Tab Bar" && (
											<Box
												sx={{
													height: "38px",
												}}
											>
												<ShowcaseTabBar showBigImage={showBigImage} />
											</Box>
										)}
									</Box>
								</div>
							</Box>
						</CardContent>
						{!["building", "built", "publishing"].find(
							(status) =>
								status ===
								(user.app.appStatuses.length === 0
									? ""
									: user.app.appStatuses.length > 0 &&
									  user.app.appStatuses[0].status)
						) && (
							<CardActions sx={{ justifyContent: "right" }}>
								<Button
									variant="contained"
									size="small"
									onClick={saveHomeData}
									disabled={loading}
								>
									{loading ? <CircularProgress size={12} /> : t("general.save")}
								</Button>
							</CardActions>
						)}
						<IconModal
							showIconMenu={showIconMenu}
							setShowIconMenu={setShowIconMenu}
							page={selectedIcon}
							setPage={setNewIcon}
						></IconModal>
					</>
				</Card>
			</Box>
		</Box>
	);
}
